import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import { isNil } from "lodash";

// HOOKS
import useSession from "Hooks/session.hook";

//SERVICES
import { fetchBox, boxAssignDriver } from "Services/delivery.services";

import { listVehicles } from "Services/delivery-settings.services";
import { fetchDriverList } from "Services/new-driver-management.services";

//HELPERS
import { decode, toaster } from "Helpers/index";
// TYPES
import { DriverApprovalStatus } from "Types/new_driver_types";

// SHARED
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

//SCSS
import "../parcel-tracking-view.scss";

import ParcelTrackingBoxesViewComponent from "Components/delivery-management/parcel-tracking-view/boxes-view-component";
import useQuery from "Hooks/query.hook";

const ParcelTrackingBoxesViewPage = ({}) => {
  const { t } = useTranslation();
  const query = useQuery();
  const { id } = useParams<{ id: string }>();
  const { org } = useSession();
  const decodedBoxID = decode(id);
  const [boxDetails, setBoxDetails] = useState<any>({});
  const [parcelDetails, setParcelDetails] = useState<any>([]);
  const [vehicleOptions, setVehicleOptions] = useState<any>([]);
  const [driverOptions, setDriverOptions] = useState<any>([]);

  const redirect = query.get("redirect");

  useEffect(() => {
    // handleListingDrivers();
    handleListingVehicles();
    fetchBoxDetails();
  }, []);

  const fetchBoxDetails = async () => {
    const responseData = await fetchBox(decodedBoxID);
    if (responseData && !responseData.error) {
      setBoxDetails(responseData);

      // clear history
      setParcelDetails && setParcelDetails([]);

      for (let i = 0; i < responseData?.orders?.length; i++) {
        setParcelDetails((parcel) => [
          ...parcel,
          { orders: responseData?.orders[i], parcelList: responseData?.parcelList[i] },
        ]);
      }
    } else {
      console.log("error message to remove");
    }
  };

  const handleListingVehicles = async () => {
    const responseData = await listVehicles({ active: true });
    setVehicleOptions(responseData);
  };

  const handleListingDrivers = async () => {
    const responseData = await fetchDriverList({}, [org._id], DriverApprovalStatus.APPROVED);
    if (responseData && !responseData.error) {
      setDriverOptions((settings) => {
        return { ...settings, DRIVER: responseData };
      });
    }
  };

  const handleAssignDriver = async (input) => {
    const responseData = await boxAssignDriver(input);

    if (!isNil(responseData) && responseData.updated) {
      toaster("success", "Assigned Driver successfully");
      fetchBoxDetails();
    } else {
      toaster("error", "Failed to update");
    }
  };

  return (
    <div>
      <Helmet>
        <title>{t("title.deliveryManagement")}</title>
      </Helmet>

      <ModuleTitleBar
        titleText={t("title.deliveryManagement")}
        haveSubtitle
        subtitleText={
          redirect ? (redirect == "sort" ? t("title.sorting") : t("title.lastMile")) : ""
        }
      />
      <ParcelTrackingBoxesViewComponent
        info={boxDetails}
        parcelDetails={parcelDetails}
        vehicleOptions={vehicleOptions}
        onAssignDriver={handleAssignDriver}
      />
    </div>
  );
};

export default ParcelTrackingBoxesViewPage;
